'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

var Reader = require('it-reader');

var log = require('debug')('it-multistream-select:ls');

var multistream = require('./multistream');

var handshake = require('it-handshake');

var lp = require('it-length-prefixed');

var pipe = require('it-pipe');

module.exports = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(stream) {
    var _handshake, reader, writer, rest, shakeStream, res, protocolsReader, protocols;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _handshake = handshake(stream), reader = _handshake.reader, writer = _handshake.writer, rest = _handshake.rest, shakeStream = _handshake.stream;
            log('write "ls"');
            multistream.write(writer, 'ls');
            rest(); // Next message from remote will be (e.g. for 2 protocols):
            // <varint-msg-len><varint-proto-name-len><proto-name>\n<varint-proto-name-len><proto-name>\n

            _context2.next = 6;
            return multistream.read(reader);

          case 6:
            res = _context2.sent;
            // After reading response we have:
            // <varint-proto-name-len><proto-name>\n<varint-proto-name-len><proto-name>\n
            protocolsReader = Reader([res]);
            protocols = []; // Decode each of the protocols from the reader

            _context2.next = 11;
            return pipe(protocolsReader, lp.decode(), /*#__PURE__*/function () {
              var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(source) {
                var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, protocol;

                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _iteratorAbruptCompletion = false;
                        _didIteratorError = false;
                        _context.prev = 2;
                        _iterator = _asyncIterator(source);

                      case 4:
                        _context.next = 6;
                        return _iterator.next();

                      case 6:
                        if (!(_iteratorAbruptCompletion = !(_step = _context.sent).done)) {
                          _context.next = 12;
                          break;
                        }

                        protocol = _step.value;
                        // Remove the newline
                        protocols.push(protocol.shallowSlice(0, -1).toString());

                      case 9:
                        _iteratorAbruptCompletion = false;
                        _context.next = 4;
                        break;

                      case 12:
                        _context.next = 18;
                        break;

                      case 14:
                        _context.prev = 14;
                        _context.t0 = _context["catch"](2);
                        _didIteratorError = true;
                        _iteratorError = _context.t0;

                      case 18:
                        _context.prev = 18;
                        _context.prev = 19;

                        if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
                          _context.next = 23;
                          break;
                        }

                        _context.next = 23;
                        return _iterator.return();

                      case 23:
                        _context.prev = 23;

                        if (!_didIteratorError) {
                          _context.next = 26;
                          break;
                        }

                        throw _iteratorError;

                      case 26:
                        return _context.finish(23);

                      case 27:
                        return _context.finish(18);

                      case 28:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee, null, [[2, 14, 18, 28], [19,, 23, 27]]);
              }));

              return function (_x2) {
                return _ref2.apply(this, arguments);
              };
            }());

          case 11:
            return _context2.abrupt("return", {
              stream: shakeStream,
              protocols: protocols
            });

          case 12:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}();